var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormCheckboxOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#CAD2D8",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2895F1",
    fillRule: "nonzero",
    d: "M3 3h9v9H3z"
  }))));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQRDk0Yld3Z2RtVnljMmx2YmowaU1TNHdJaUJsYm1OdlpHbHVaejBpVlZSR0xUZ2lQejRLUEhOMlp5QjNhV1IwYUQwaU1UVndlQ0lnYUdWcFoyaDBQU0l4TlhCNElpQjJhV1YzUW05NFBTSXdJREFnTVRVZ01UVWlJSFpsY25OcGIyNDlJakV1TVNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWlCNGJXeHVjenA0YkdsdWF6MGlhSFIwY0RvdkwzZDNkeTUzTXk1dmNtY3ZNVGs1T1M5NGJHbHVheUkrQ2lBZ0lDQThkR2wwYkdVK1ptOXliUzFqYUdWamEySnZlQzF2Ymp3dmRHbDBiR1UrQ2lBZ0lDQThaeUJwWkQwaVVHRm5aUzB4SWlCemRISnZhMlU5SW01dmJtVWlJSE4wY205clpTMTNhV1IwYUQwaU1TSWdabWxzYkQwaWJtOXVaU0lnWm1sc2JDMXlkV3hsUFNKbGRtVnViMlJrSWo0S0lDQWdJQ0FnSUNBOFp5QnBaRDBpWm05eWJTMWphR1ZqYTJKdmVDMXZiaUkrQ2lBZ0lDQWdJQ0FnSUNBZ0lEeG5JR2xrUFNKU1pXTjBZVzVuYkdVdE1UQTVMVU52Y0hrdE15SStDaUFnSUNBZ0lDQWdJQ0FnSUNBZ0lDQThaeUJwWkQwaWNHRjBhQzB4TFd4cGJtc2lJR1pwYkd3OUlpTkdSa1pHUmtZaVBnb2dJQ0FnSUNBZ0lDQWdJQ0FnSUNBZ0lDQWdJRHh5WldOMElHbGtQU0p3WVhSb0xURWlJSGc5SWpBaUlIazlJakFpSUhkcFpIUm9QU0l4TlNJZ2FHVnBaMmgwUFNJeE5TSWdjbmc5SWpFaVBqd3ZjbVZqZEQ0S0lDQWdJQ0FnSUNBZ0lDQWdJQ0FnSUR3dlp6NEtJQ0FnSUNBZ0lDQWdJQ0FnSUNBZ0lEeHlaV04wSUdsa1BTSlNaV04wWVc1bmJHVWlJSE4wY205clpUMGlJME5CUkRKRU9DSWdlRDBpTUM0MUlpQjVQU0l3TGpVaUlIZHBaSFJvUFNJeE5DSWdhR1ZwWjJoMFBTSXhOQ0lnY25nOUlqRWlQand2Y21WamRENEtJQ0FnSUNBZ0lDQWdJQ0FnUEM5blBnb2dJQ0FnSUNBZ0lDQWdJQ0E4Y21WamRDQnBaRDBpVW1WamRHRnVaMnhsTFRFd09TMURiM0I1TFRjaUlHWnBiR3c5SWlNeU9EazFSakVpSUdacGJHd3RjblZzWlQwaWJtOXVlbVZ5YnlJZ2VEMGlNeUlnZVQwaU15SWdkMmxrZEdnOUlqa2lJR2hsYVdkb2REMGlPU0krUEM5eVpXTjBQZ29nSUNBZ0lDQWdJRHd2Wno0S0lDQWdJRHd2Wno0S1BDOXpkbWMrIg==";
export { SvgFormCheckboxOn as ReactComponent };